import React from "react";
import PropTypes from "prop-types";
import { DropDown, CalendarWidget, Loader } from "@src/components/atoms";
import moment from "moment";
import AppUtils from "@src/utils/appUtils";

/** Monthly calendar of emails sent each day, hover for a tooltip with details */
const EmailScheduleCard = ({
  title,
  notificationPeriodOptions,
  selectedNotificationPeriod,
  selectedNotificationPeriodOnChange,
  notificationScheduleMap,
  selectedDay,
  selectedDayOnChange,
  isLoading = false,
}) => {
  const notificationPeriod = moment.utc(selectedNotificationPeriod, "YYYY-MM");
  const month = notificationPeriod.month();
  const year = notificationPeriod.year();

  return (
    <div className="pt-8 px-12">
      <div className="font-bold md:font-extrabold text-base md:text-lg text-neutral-500 mb-4">
        {title}
      </div>
      <div className="w-1/2 mb-8">
        <DropDown
          options={notificationPeriodOptions}
          value={selectedNotificationPeriod}
          onChange={selectedNotificationPeriodOnChange}
        />
      </div>
      <div className="flex justify-center">
        {isLoading ? (
          <div style={{ height: "275px" }}>
            <Loader size="2xl" />
          </div>
        ) : (
          <CalendarWidget
            month={month}
            year={year}
            daysWithData={notificationScheduleMap}
            selectedDay={selectedDay}
            selectedDayOnChange={selectedDayOnChange}
          />
        )}
      </div>
    </div>
  );
};

export const emailScheduleCardControls = {};
EmailScheduleCard.propTypes = AppUtils.getPropTypeFromControls(
  emailScheduleCardControls,
);

export default EmailScheduleCard;
